export default __webpack_public_path__ + "static/media/Collectibles.8526f215.pdf";